import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { store } from 'redux-rest-reducer';
import { postStudent } from 'actions/parent-lead';

import Form from 'comps/form';
import { Button, Text, Separator } from '@cuemath/comps';
import { GRADES } from 'constants/constants';
import {
  genderOptions as Genders,
  GradeOptions,
  PlusLeadOptions,
  EthnicityOptions,
  OPTIONS,
  studentSourceOptions as StudentSources,
} from 'constants/form';
import { COLORS } from '@cuemath/comps';
import WarningPopup from './warning-popup';

const AddGradeOptions = Object.keys(GRADES).map(item => ({
  label: GRADES[item],
  value: item,
}));

let FORM = [
  {
    id: 'firstName',
    label: 'First Name',
    type: 'text',
    maxLength: '50',
    autoFocus: true,
  },
  {
    id: 'lastName',
    label: 'Last Name',
    maxLength: '50',
    type: 'text',
  },
  {
    id: 'gender',
    label: 'Gender (Optional)',
    type: 'dropdown',
    options: Genders,
  },
  {
    id: 'grade',
    label: 'Grade',
    type: 'dropdown',
    options: GradeOptions,
  },
  {
    id: 'schoolName',
    label: 'School Name (Optional)',
    maxLength: '50',
    type: 'text',
  },
  {
    id: 'plusLead',
    label: 'Plus Lead',
    type: 'dropdown',
    options: PlusLeadOptions,
  },
  {
    id: 'ethnicity',
    label: 'Ethnicity (Optional)',
    type: 'dropdown',
    options: EthnicityOptions,
  },
];

const StyledForm = styled.form`
  @media (min-width: 767px) {
    width: 40%;
    margin: 50px auto;
  }
`;

class AddStudentForm extends Component {
  state = {
    form: {
      firstName: undefined,
      lastName: undefined,
      grade: undefined,
      gender: undefined,
      schoolName: undefined,
      plusLead: undefined,
      ethnicity: undefined,
    },
    validation: {},
    error: {},
    disables: {},
    postParentStudentsResponse: store.post(),
    studentId: undefined,
    genericError: {},
    successfulMessage: {},
    parentId: {},
  };

  static getDerivedStateFromProps(props, state) {
    const { parentStudents, searchObj, history, parentId } = props;
    let { postParentStudentsResponse, disables, error, genericError, successfulMessage } =
      state || {};
    postParentStudentsResponse = store.post(parentStudents, parentId);
    const { resolved } = postParentStudentsResponse;

    if (resolved) {
      if (resolved.isCreatingFailed) {
        error = store.getError(resolved);
        genericError = { message: 'Something went wrong. Please try again!' };
      } else if (resolved.isCreated) {
        error = {};
        successfulMessage = {
          successMessage:
            'Successfully created lead, please wait some time for the same to relfect on LSQ',
        };
      }
    }

    if (searchObj) {
      Object.keys(searchObj).forEach(k => {
        disables[k] = true;
      });
    }

    return {
      postParentStudentsResponse,
      error,
      disables,
      form: {
        ...state.form,
        ...searchObj,
        grade:
          AddGradeOptions.find(({ value }) => value === searchObj.grade) ||
          state.form.grade,
      },
      studentId: searchObj && searchObj.id,
      genericError,
      successfulMessage,
      parentId,
    };
  }

  onFormChange = (nextData, nextValidation) => {
    const formData = {};

    Object.keys(nextData).forEach(k => {
      formData[k] = formData[k] = nextData[k].target
        ? nextData[k].target.value
        : nextData[k];
    });

    this.setState(prevState => ({
      form: {
        ...prevState.form,
        ...formData,
      },
      validation: {
        ...prevState.validation,
        ...nextValidation,
      },
      genericError: {
        ...prevState.genericError,
        message: '',
      },
      successfulMessage: {
        ...prevState.successfulMessage,
        successMessage: '',
      },
    }));
  };

  createStudentAfterWarningPopup = () => {
    const { parentId, actions, searchObj } = this.props;
    const {
      postParentStudentsResponse: { id = '', current = {} },
      form,
      studentId,
    } = this.state;

    this.postForm(form, searchObj, actions, parentId, 'create_student');
  };

  onSubmit = event => {
    event.preventDefault();
    const { parentId, actions, searchObj } = this.props;
    const {
      postParentStudentsResponse: { id = '', current = {} },
      form,
      studentId,
    } = this.state;

    if (current && current.isCreating) {
      return;
    }
    const requiredFieldsError = {};
    const notFilled = Object.keys(form).filter(k => {
      let mandatoryFieldsNotFilled =
        k !== 'gender' &&
        k !== 'schoolName' &&
        k !== 'ethnicity' &&
        k !== OPTIONS.LAST_NAME &&
        !form[k];
      if (mandatoryFieldsNotFilled) {
        requiredFieldsError[k] = 'Required';
      }

      return mandatoryFieldsNotFilled;
    });
    if (notFilled.length) {
      this.setState({ error: { fields: requiredFieldsError } });
      return;
    }

    this.postForm(form, searchObj, actions, parentId, 'validate_create_student');
  };

  postForm(form, searchObj, actions, parentId, actionName) {
    const { firstName, lastName, grade, gender, schoolName, plusLead, ethnicity } = form;
    const { phoneNumber } = searchObj;

    let payload = {
      action: actionName,
      phone: phoneNumber,
      first_name: firstName,
      last_name: lastName ? lastName : '',
      grade: grade && grade.value,
      gender: gender ? gender.value : '',
      school_name: schoolName || '',
      plus_lead: plusLead && plusLead.value,
      ethnicity: ethnicity && ethnicity.value,
    };

    actions.postStudent(parentId, payload);
  }

  openNewTabAndReload(student_id) {
    setTimeout(() => {
      window.location.reload();
    }, 500);
    if (student_id) {
      window.open(`https://leap-admin.cuemath.com/student-form/${student_id}`);
    }
    return;
  }

  render() {
    const {
      form,
      validation,
      error,
      postParentStudentsResponse,
      disables,
      genericError,
      successfulMessage,
      parentId,
    } = this.state;

    const { message = '' } = genericError || {};
    const { successMessage = '' } = successfulMessage || {};
    const { message: errorMessage = '' } = error || {};
    const { resolved } = postParentStudentsResponse || {};
    const { isCreated } = resolved || {};
    const { data = {} } = resolved || {};
    const {
      intel_enrollment_id: intelEnrollmentId = '',
      parent_service_id: parentServiceId = '',
    } = data || {};

    return (
      <StyledForm onSubmit={this.onSubmit}>
        <Text size="larger" weight="bolder">
          Enter student details
        </Text>

        <WarningPopup
          message={message}
          warningAccepted={this.createStudentAfterWarningPopup}
          parentId={parentId}
          error={errorMessage}
        />
        {successMessage && isCreated && (
          <>
            <Text color={COLORS.GREEN} size="larger" weight="bolder">
              Student added successfully!
            </Text>
            <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
              {intelEnrollmentId && (
                <a
                  href={`https://leap-admin.cuemath.com/student-form/${intelEnrollmentId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View in Leap Admin
                </a>
              )}
              {parentServiceId && (
                <a
                  href={`https://admin.cuemath.com/parent/admin/student/?flt_parent_id_equals=${parentServiceId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Parent's Students
                </a>
              )}
            </div>
          </>
        )}
        <Form
          nodes={FORM}
          values={form}
          validations={validation}
          error={error}
          onChange={this.onFormChange}
          disables={disables}
        />
        <Button label="Create Lead" id="submit" />
      </StyledForm>
    );
  }
}

AddStudentForm.propTypes = {
  actions: PropTypes.shape({
    postParentStudents: PropTypes.func.isRequired,
  }).isRequired,
  parentId: PropTypes.string.isRequired,
};

export default connect(
  (
    { parentStudents },
    {
      match: {
        params: { parentId },
      },
      location: { search } = {},
    },
  ) => {
    const searchObj = parse(search);

    return {
      parentStudents,
      parentId,
      searchObj,
    };
  },
  dispatch => ({
    actions: bindActionCreators({ postStudent }, dispatch),
  }),
)(AddStudentForm);
